import { useContext } from 'react';
import { CardContext } from '../../utils/cardContext';
import { Gallery as GalleryComponent } from '../../components/Gallery';

export const Gallery = () => {
  const layout = useContext(CardContext);

  return <GalleryComponent images={layout.images} url={layout.url} />;
};
